import { useState } from "react";

const initialValidityState = {
  badInput: false,
  customError: false,
  patternMismatch: false,
  rangeOverflow: false,
  rangeUnderflow: false,
  stepMismatch: false,
  tooLong: false,
  tooShort: false,
  typeMismatch: false,
  valid: true,
  valueMissing: false,
};

const useConstraintValidation = (inputElement) => {
  const [validityState, setValidityState] = useState(initialValidityState);

  const [
    allowPerKeystrokeValidation,
    setAllowPerKeystrokeValidation,
  ] = useState(false);

  const checkValidity = () => {
    // automatically calls invalid event when invalid
    // valid state has to be updated manually
    if (inputElement?.checkValidity()) {
      setValidityState(initialValidityState);
    }
  };

  const onBlurValidityCheck = () => {
    if (!allowPerKeystrokeValidation) setAllowPerKeystrokeValidation(true);
    checkValidity();
  };

  const onChangeValidityCheck = () => {
    if (allowPerKeystrokeValidation) {
      checkValidity();
    }
  };

  const handleInvalid = (invalidEvent, preventDefaultErrorTooltips = true) => {
    if (preventDefaultErrorTooltips) {
      invalidEvent.preventDefault();
    }
    setAllowPerKeystrokeValidation(true);

    const {
      badInput,
      customError,
      patternMismatch,
      rangeOverflow,
      rangeUnderflow,
      stepMismatch,
      tooLong,
      tooShort,
      typeMismatch,
      valid,
      valueMissing,
    } = invalidEvent.target.validity;

    // validity is a class instance therefore can't be copied with spread operator
    setValidityState({
      badInput,
      customError,
      patternMismatch,
      rangeOverflow,
      rangeUnderflow,
      stepMismatch,
      tooLong,
      tooShort,
      typeMismatch,
      valid,
      valueMissing,
    });
  };

  const {
    badInput,
    customError,
    patternMismatch,
    rangeOverflow,
    rangeUnderflow,
    stepMismatch,
    tooLong,
    tooShort,
    typeMismatch,
    valid,
    valueMissing,
  } = validityState;

  return {
    handleInvalid,
    badInput,
    customError,
    patternMismatch,
    rangeOverflow,
    rangeUnderflow,
    stepMismatch,
    tooLong,
    tooShort,
    typeMismatch,
    valid,
    valueMissing,
    allowPerKeystrokeValidation,
    invalidNotMissing: !valid && !valueMissing,
    onBlurValidityCheck,
    onChangeValidityCheck,
  };
};

export default useConstraintValidation;
